import ServicesRegistry from './services_registry';
import BaseSingleton from '../base/base_singleton';
import IAbTestingService from './ab_testing/ab_testing_service_interface';
import IAiListService from './ai_list/ai_list_service_interface';
import IAnalyticsService from './analytics/analytics_service_interface';
import ICasinofiedAnalyticsProxyService from './analytics/casinofied_analytics_proxy_service_interface';
import ICashierProxy from './cashier_proxy/cashier_proxy_service_interface';
import ICasinofiedAppLauncherProxyService from './casinofied_app_launcher_proxy/casinofied_app_launcher_proxy_service_interface';
import IClockService from './clock/clock_service_interface';
import IConfigService from './config/config_service_interface';
import ICountryService from './country/country_service_interface';
import ICurrencyService from './currency/currency_service_interface';
import IEvolutionService from './evolution/evolution_service_interface';
import IExternalLinksProxyService from './external_links_proxy/external_links_proxy_service_interface';
import IGameRunnerProxyService from './game/game_runner_proxy_service_interface';
import IGamesInformationService from './games_information/games_information_service_interface';
import IGeoRetryService from './geo_location/geo_retry_service_interface';
import IGeoService from './geo_location/geo_service_interface';
import ISdkGnwpService from './gnwp/gnwp_service_interface';
import IHistoryService from './history/history_service_interface';
import IHttp2Service from './http/http2_service_interface';
import ILanguageService from './language/language_service_interface';
import IJackpotFeedsService from './live_feeds/jackpots/jackpot_feeds_service_interface';
import ILiveTablesService from './live_tables/live_tables_service_interface';
import IMessageManagerService from './message_manager/message_manager_service_interface';
import INetEntService from './netent/netent_service_interface';
import IUserService from './oauth/user/user_service_interface';
import IObservableFactoryService from './observable_factory/observable_factory_service_interface';
import IOrbitComponentRenderService from './orbit_component_renderer/orbit_component_render_service_interface';
import IOverlayManager from './overlay_manager/overlay_manager_service_interface';
import IRecentlyPlayedService from './recently_played/recently_played_service_interface';
import IRestrictions from './restrictions/restrictions_service_interface';
import ISafezoneLoaderService from './safezone_loader/safezone_loader_service_interface';
import IScriptLoaderService from './script_loader/script_loader_service_interface';
import ISkinService from './skin/skin_service_interface';
import StructuredLoggingServiceInterface from './structured_logging/structured_logging_service_interface';
import ITimeService from './time/time_service_interface';
import IToasterService from './toaster/toaster_service_interface';
import IWebPushService from './web_push/web_push_service_interface';
import IWindowService from './window/window_service_interface';

export default class ServiceFactory extends BaseSingleton {

	private servicesRegistry: ServicesRegistry;

	init() {
		this.servicesRegistry = ServicesRegistry.create({});
	}
	abTestingService(): IAbTestingService {
		return this.servicesRegistry.getService('AbTestingService') as IAbTestingService;
	}
	aiListService(): IAiListService {
		return this.servicesRegistry.getService('AiListService') as IAiListService;
	}
	analyticsService(): IAnalyticsService {
		return this.servicesRegistry.getService('AnalyticsService') as IAnalyticsService;
	}
	casinofiedAnalyticsProxyService(): ICasinofiedAnalyticsProxyService {
		return this.servicesRegistry.getService('CasinofiedAnalyticsProxyService') as ICasinofiedAnalyticsProxyService;
	}
	bonusAbuseParkingMoneyInSportAndPokerService(): any {
		return this.servicesRegistry.getService('BonusAbuseParkingMoneyInSportAndPokerService');
	}
	cashierProxyService(): ICashierProxy {
		return this.servicesRegistry.getService('CashierProxyService') as ICashierProxy;
	}
	casinofiedAppLauncherProxyService(): ICasinofiedAppLauncherProxyService {
		return this.servicesRegistry.getService('CasinofiedAppLauncherProxyService') as ICasinofiedAppLauncherProxyService;
	}
	clockService(): IClockService {
		return this.servicesRegistry.getService('ClockService') as IClockService;
	}
	componentFactoryService(): any {
		return this.servicesRegistry.getService('ComponentFactoryService');
	}
	configService(): IConfigService {
		return this.servicesRegistry.getService('ConfigService') as IConfigService;
	}
	countryService(): ICountryService {
		return this.servicesRegistry.getService('CountryService') as ICountryService;
	}
	currencyService(): ICurrencyService {
		return this.servicesRegistry.getService('CurrencyService') as ICurrencyService;
	}
	domainDetectionService(): any {
		return this.servicesRegistry.getService('DomainDetectionService');
	}
	evolutionService(): IEvolutionService {
		return this.servicesRegistry.getService('EvolutionService') as IEvolutionService;
	}
	externalLinksProxyService(): IExternalLinksProxyService {
		return this.servicesRegistry.getService('ExternalLinksProxyService') as IExternalLinksProxyService;
	}
	gameRunnerProxyService(): IGameRunnerProxyService {
		return this.servicesRegistry.getService('GameRunnerProxyService') as IGameRunnerProxyService;
	}
	gameService(): any {
		return this.servicesRegistry.getService('GameService');
	}
	gamesCorrelationService(): any {
		return this.servicesRegistry.getService('GamesCorrelationService');
	}
	gamesInformationService(): IGamesInformationService {
		return this.servicesRegistry.getService('GamesInformationService') as IGamesInformationService;
	}
	gamesQuestionnaireService(): any {
		return this.servicesRegistry.getService('GamesQuestionnaireService');
	}
	gameManagerService(): any {
		return this.servicesRegistry.getService('GameManagerService');
	}
	gameReasonService(): any {
		return this.servicesRegistry.getService('GameReasonService');
	}
	geoRetryService(): IGeoRetryService {
		return this.servicesRegistry.getService('GeoRetryService') as IGeoRetryService;
	}
	geoLocationService(): IGeoService {
		return this.servicesRegistry.getService('GeoLocationService') as IGeoService;
	}
	gnwpService(): ISdkGnwpService {
		return this.servicesRegistry.getService('GnwpService') as ISdkGnwpService;
	}
	historyService(): IHistoryService {
		return this.servicesRegistry.getService('HistoryService') as IHistoryService;
	}
	http2Service(): IHttp2Service {
		return this.servicesRegistry.getService('Http2Service') as IHttp2Service;
	}
	hybridService(): any {
		return this.servicesRegistry.getService('HybridService');
	}
	hybridVersionHandlerService(): any {
		return this.servicesRegistry.getService('HybridVersionHandlerService');
	}
	idleRecommendationsService(): any {
		return this.servicesRegistry.getService('IdleRecommendationsService');
	}
	integrationService(): any {
		return this.servicesRegistry.getService('IntegrationService');
	}
	jackpotToastersService(): any {
		return this.servicesRegistry.getService('JackpotToastersService');
	}
	languageService(): ILanguageService {
		return this.servicesRegistry.getService('LanguageService') as ILanguageService;
	}
	jackpotFeedsService(): IJackpotFeedsService {
		return this.servicesRegistry.getService('JackpotFeedsService') as IJackpotFeedsService;
	}
	liveTablesService(): ILiveTablesService {
		return this.servicesRegistry.getService('LiveTablesService') as ILiveTablesService;
	}
	menuService(): any {
		return this.servicesRegistry.getService('MenuService');
	}
	messageManagerService(): IMessageManagerService {
		return this.servicesRegistry.getService('MessageManagerService') as IMessageManagerService;
	}
	netEntService(): INetEntService {
		return this.servicesRegistry.getService('NetEntService') as INetEntService;
	}
	oAuth2Service(): any {
		return this.servicesRegistry.getService('OAuth2Service');
	}
	userService(): IUserService {
		return this.servicesRegistry.getService('UserService') as IUserService;
	}
	observableFactoryService(): IObservableFactoryService {
		return this.servicesRegistry.getService('ObservableFactoryService') as IObservableFactoryService;
	}
	openLinkService(): any {
		return this.servicesRegistry.getService('OpenLinkService');
	}
	orbitComponentRenderService(): IOrbitComponentRenderService {
		return this.servicesRegistry.getService('OrbitComponentRenderService') as IOrbitComponentRenderService;
	}
	overlayManagerService(): IOverlayManager {
		return this.servicesRegistry.getService('OverlayManagerService') as IOverlayManager;
	}
	pendingActionService(): any {
		return this.servicesRegistry.getService('PendingActionService');
	}
	playerMigrationProxyService(): any {
		return this.servicesRegistry.getService('PlayerMigrationProxyService');
	}
	playerMessagesService(): any {
		return this.servicesRegistry.getService('PlayerMessagesService');
	}
	fallbackService(): any {
		return this.servicesRegistry.getService('FallbackService');
	}
	firebaseElasticService(): any {
		return this.servicesRegistry.getService('FirebaseElasticService');
	}
	postMessageService(): any {
		return this.servicesRegistry.getService('PostMessageService');
	}
	queryStringDetectorService(): any {
		return this.servicesRegistry.getService('QueryStringDetectorService');
	}
	recentlyPlayedService(): IRecentlyPlayedService {
		return this.servicesRegistry.getService('RecentlyPlayedService') as IRecentlyPlayedService;
	}
	regulationService(): any {
		return this.servicesRegistry.getService('RegulationService');
	}
	resizeDetectorService(): any {
		return this.servicesRegistry.getService('ResizeDetectorService');
	}
	restrictionsService(): IRestrictions {
		return this.servicesRegistry.getService('RestrictionsService') as IRestrictions;
	}
	safezoneLoaderService(): ISafezoneLoaderService {
		return this.servicesRegistry.getService('SafezoneLoaderService') as ISafezoneLoaderService;
	}
	scriptLoaderService(): IScriptLoaderService {
		return this.servicesRegistry.getService('ScriptLoaderService') as IScriptLoaderService;
	}
	skinService(): ISkinService {
		return this.servicesRegistry.getService('SkinService') as ISkinService;
	}
	structuredLoggingService(): StructuredLoggingServiceInterface {
		return this.servicesRegistry.getService('StructuredLoggingService') as StructuredLoggingServiceInterface;
	}
	themesService(): any {
		return this.servicesRegistry.getService('ThemesService');
	}
	timeService(): ITimeService {
		return this.servicesRegistry.getService('TimeService') as ITimeService;
	}
	toasterService(): IToasterService {
		return this.servicesRegistry.getService('ToasterService') as IToasterService;
	}
	trackjsService(): any {
		return this.servicesRegistry.getService('TrackjsService');
	}
	visibilityDetectorService(): any {
		return this.servicesRegistry.getService('VisibilityDetectorService');
	}
	walletService(): any {
		return this.servicesRegistry.getService('WalletService');
	}
	webLoginService(): any {
		return this.servicesRegistry.getService('WebLoginService');
	}
	webPushService(): IWebPushService {
		return this.servicesRegistry.getService('WebPushService') as IWebPushService;
	}
	windowService(): IWindowService {
		return this.servicesRegistry.getService('WindowService') as IWindowService;
	}
}

